import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { CircularProgress, Button } from '@material-ui/core';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { arrayBufferFromBase64, openFile } from "../../../ActivityCenter/SubComponents/caseFiles";
import { format } from 'date-fns';
import '../../../Common/Table.scss';
import { httpRequest } from '../../../../httpRequest';
import { ConvertUTCToLocalDateTime } from '../../../Helpers/Formatters/UTCToLocalDate';

const useStyles = makeStyles((theme) => ({
  activePage: {
    color: `${theme.palette.primary.main} !important`,
    fontWeight: 'bold',
    borderBottom: '2px solid black'
  },
  headerColor: {
    backgroundColor: `${theme.palette.primary.main}08`
  },
  removeLink:
  {
    color: 'red',
    fontWeight: '600'
  },
  nameColor: {
    color: theme.palette.primary.main,
  },
  pointer: {
    cursor: "pointer"
  }
}));
export default function FileTable(props) {

  const { stateUpdate, state, postingApp, fileData, IllustrationRequest,isPermReview,isRequestedLedger } = props;
  const { fileList, nextPageMax, pageNumber, totalPages, pageForwardVisible, pageBackVisible } = props.state;

  const classes = useStyles();


  if (postingApp) {
    return <FileTableLoadingView isPermReview = {isPermReview}/>;
  }

  if (!fileList || fileList.length === 0) {
    return <FileTableNoResultsFoundView isPermReview = {isPermReview}/>;
  }

  let items = [];

  const readFile = (index, value) => {
    const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;
    props.setPosting(true);
    let openFileData;
    if ((IllustrationRequest && value.versions) || (props.imageId && !props.value)) {

      const queryParamsFile = new URLSearchParams({
        imageId: (value.version && Number(value.versions[0].imageID) )|| props.imageId,
      });
      httpRequest.get(`${covrServicesUrl}/api/Advisor/GetExternalImageFileData?${queryParamsFile.toString()}`)
        .then(data => {
          if (data) {
            let extension = (value.version && value.versions[0].fileExtension) || (value.extension);
            let type;
            if (extension === 'pdf') {
              type = 'application/pdf';
            }
            else if (extension === 'tif' || extension === 'tiff' || extension === 'mtiff') {
              type = 'image/tiff'
            }
            openFile(arrayBufferFromBase64(data.data), type);
            props.setPosting(false);
          }
        })
    } else {
      if (value.key !== null) {
        httpRequest.get(`${covrServicesUrl}/api/Case/GetFileData?key=${value.key}`)
          .then((data) => {
            if (data) {
              openFile(arrayBufferFromBase64(data), value.extension);
              props.setPosting(false);
            }
          }).catch((error) => {
            openFileData = null;
            props.setPosting(false);
          });
      }
      else if (fileData[index]) {
        openFileData = arrayBufferFromBase64(fileData[index].split(',')[1]);
        openFile(openFileData, value.extension);
        props.setPosting(false);
      }
      else {
        openFileData = null
      }
    }
  }

  for (const [index, value] of fileList.entries()) {
    items.push(
      <Row key={index} className="cases">
        <Col sm={value.FileType ? 3 : 5} className={`mt-3 case-type ${classes.nameColor} ${classes.pointer}`}><span onClick={() => isPermReview ? null : readFile(index, value)}>{IllustrationRequest && value.versions ? value.versions[index].fileName : value.name || value.FileName}</span></Col>
        {
          value.FileType && 
          <Col sm={4} className='mt-3'>{ value.FileType === "Ledger"  ?isRequestedLedger ?'In-Force Ledger Request Document':'In-Force Ledger Document':'Additional Files (Quotes, Illustrations, etc)'}</Col>
        }
        <Col sm={value.FileType ?3:5} className='mt-3'>{(IllustrationRequest && value.versions) ? (format(new Date(value.versions[index].dateCreatedUTC), 'MM/dd/yyyy')) : (IllustrationRequest ? (ConvertUTCToLocalDateTime(format(new Date(value.dateTime), 'MM/dd/yyyy hh:mm')) || ConvertUTCToLocalDateTime(format(new Date(value.CreatedDate), 'MM/dd/yyyy hh:mm'))) : (value.dateTime || value.CreatedDate))}</Col>
        <Col sm={value.FileType ?2:2} className='mt-2'><Button onClick={() => props.removeFile(value)} className={classes.removeLink}>REMOVE FILE</Button></Col>
      </Row>
    )
    items.push(<div key={index + "solid"} className="solid" />)
  }

  let pageNumbers = [];
  let firstPage = nextPageMax - 4;

  for (var i = firstPage; i <= nextPageMax && i <= totalPages; i++) {
    pageNumbers.push(i);
  }
  var pages = pageNumbers.map((v, i) => {
    return <a key={i} onClick={() => { stateUpdate({ ...state, pageNumber: v, updateFileTable: true }); window.scrollTo(0, 0); }} className={`case-table-page ${pageNumber === v ? classes.activePage : ''}`}>{v}</a>;
  });

  const handlePageBackClick = (pageNumber) => {
    stateUpdate({ ...state, pageNumber: nextPageMax - 9, updateFileTable: true });

    window.scrollTo(0, 0);
  }

  const handlePageForwardClick = (pageNumber) => {
    stateUpdate({ ...state, pageNumber: nextPageMax + 1, updateFileTable: true });

    window.scrollTo(0, 0);
  }

  return (
    <div className="border">
      <Row className={`header-blue ${classes.headerColor}`}>
        <Col sm={isPermReview ?3:5} className='mt-1'>Name</Col>
        {
          isPermReview ? <Col sm={4} className='mt-1'>Type</Col> : null
        }
        <Col sm={isPermReview ?3:5} className='mt-1'>Date Created</Col>
        <Col sm={isPermReview ?2:2} className='mt-1'></Col>
      </Row>
      {items}
      <Row className="prevNext">
        <Col className="prevNextButtons" sm={2}>
          {pageBackVisible && pageNumber > 5 ?
            <a onClick={() => handlePageBackClick(pageNumber)}>
              <Button color="primary">
                <ArrowBackIosIcon color="primary" fontSize="small" /> PREV
              </Button>
            </a>
            : ''}
        </Col>
        <Col className="case-table-paging" sm={8}>
          {pages}
        </Col>
        <Col className="prevNextButtons" style={{ "float": "right" }} sm={2}>
          {pageForwardVisible ?
            <a onClick={() => handlePageForwardClick(pageNumber)}>
              <Button color="primary">
                NEXT <ArrowForwardIosIcon color="primary" fontSize="small" />
              </Button>
            </a>
            : ''}
        </Col>
      </Row>
    </div>
  );
}

FileTable.propTypes = {
  state: PropTypes.shape({
    fileList: PropTypes.array.isRequired,
    filesLoading: PropTypes.bool.isRequired
  }).isRequired,
  stateUpdate: PropTypes.func.isRequired,
}

function FileTableLoadingView(props) {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className="border">
        <Row className={`header-blue ${classes.headerColor}`}>
          <Col sm={3} className='mt-1'>Name</Col>
          {
              props.isPermReview ? <Col sm={4} className='mt-1'>Type</Col> : null
          }
          <Col sm={props.isPermReview ? 3:2} className='mt-1'>Date Created</Col>
          <Col sm={3} className='mt-1'></Col>
        </Row>
        <div className="loading-container-table">
          <CircularProgress />
        </div>
      </div>
    </React.Fragment>
  )
}

function FileTableNoResultsFoundView(props) {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className="border">
        <Row className={`header-blue ${classes.headerColor}`}>
          <Col sm={3} className='mt-1'>Name</Col>
          {
              props.isPermReview ? <Col sm={4} className='mt-1'>Type</Col> : null
          }
          <Col sm={props.isPermReview ? 3 :2} className='mt-1'>Date Created</Col>
          <Col sm={3} className='mt-1'></Col>
        </Row>
        <div className="noresults-container">
          <Row className="justify-content-center d-flex pt-2">
            No file results found.
          </Row>
        </div>
        <Row>
        </Row>
      </div>
    </React.Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/SubComponents/FileTable.js